import api from '../services/api';

const state = {
  useCategories: true,
  showCategoriesAsButtons: false,
  usePrintDialog: false,
  showTimestampOnDates: false,
  settingsVersion: 0,
  loaded: false,
};

const getters = {
  useCategories: (state) => state.useCategories,
  showCategoriesAsButtons: (state) => state.showCategoriesAsButtons,
  usePrintDialog: (state) => state.usePrintDialog,
  showTimestampOnDates: (state) => state.showTimestampOnDates,
  settingsVersion: (state) => state.settingsVersion,
  showCategoryOnProduct: (state) => state.showCategoryOnProduct,
  showAlias: (state) => state.showAlias,
  useAliasAsTitle: (state) => state.useAliasAsTitle,
  todaysDateInclusive: (state) => state.todaysDateInclusive,
};

const mutations = {
  SET_USE_CATEGORIES(state, value) {
    state.useCategories = value;
  },
  SET_ALL_SETTINGS(state, settings) {
    state.useCategories = settings.useCategories ?? true;
    state.showCategoriesAsButtons = settings.showCategoriesAsButtons ?? false;
    state.usePrintDialog = settings.usePrintDialog ?? false;
    state.showTimestampOnDates = settings.showTimestampOnDates ?? false;
    state.settingsVersion = settings.settingsVersion ?? 0;
    state.showCategoryOnProduct = settings.showCategoryOnProduct ?? true;
    state.showAlias = settings.showAlias ?? false;
    state.useAliasAsTitle = settings.useAliasAsTitle ?? false;
    state.todaysDateInclusive = settings.todaysDateInclusive ?? false;
    state.loaded = true;
  },
};

const actions = {
  async fetchSettings({ commit }) {
    try {
      const response = await api.get('/customer-settings');
      commit('SET_ALL_SETTINGS', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch customer settings:', error);
      // Fall back to defaults — don't crash
      return null;
    }
  },

  async updateSettings({ commit }, data) {
    try {
      const response = await api.put('/customer-settings', data);
      commit('SET_ALL_SETTINGS', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to update customer settings:', error);
      throw error;
    }
  },

  // Legacy support — still used by SettingsView localStorage toggle
  toggleCategories({ commit }, value) {
    commit('SET_USE_CATEGORIES', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};